$(function () {
    slider();
    sliderView();
    sliderViewSmall();
    sliderViewMedium();
    quantitySelector();
    $('.counter').countUp();
    sliderProd();
    swipers();
    filterPrice();
    cart();
    megamenu();
    product();
    productMob();
    menuMobile();
    stickyMobile();
    addToCart();
    invoice();
    addressForm();
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});




function swipers(){
  $('[data-swiper]').each(function(){
    var opt = {
      autoHeight: false
    };
    if($(this).attr('data-swiper-pagination') != undefined){
      opt.pagination = {
        el: ".swiper-pagination",
        draggable: true,
        dynamicBullets: true
      };
    }
    if($(this).attr('data-swiper-navigation') != undefined){
      opt.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if($(this).attr('data-swiper-scrollbar') != undefined){
      opt.scrollbar = {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: true
      };
    }
    if(parseInt($(this).attr('data-swiper-autoplay')) > 0){
      opt.autoplay = {
        delay: $(this).attr('data-swiper-autoplay'),
        disableOnInteraction: false,
      };
    }
    if($(this).attr('data-swiper-autowidth') != undefined){
      opt.slidesPerView = "auto";
      opt.spaceBetween = 0;
    } else if($(this).attr('data-swiper-breakpoints') != undefined){
      var points = $(this).attr('data-swiper-breakpoints').split(',');
      opt.spaceBetween = 0;
      opt.breakpoints = {};
      $(points).each(function(){
        var els = this.split(':');
        if(els[0].localeCompare('default') == 0){
          opt.slidesPerView = els[1];
        } else {
          opt.breakpoints[els[0]] = {
            slidesPerView: els[1]
          }
        }
      });
    }
    try{
      var swiper = new Swiper(this, opt);
    } catch{
      console.log('error with swiper');
    }
  });
}


function slider(){
    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}


function sliderViewMedium(){
  $('.mySwiperViewMedium').each(function(){
    new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: ".swiper-pagination-view",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
    });
  })
}

function sliderView(){
  $('.mySwiperView').each(function(){
    new Swiper(this, {
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: {
            el: ".swiper-pagination-view",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
    });
  })
}


function sliderViewSmall(){
  var swiper = new Swiper(".mySwiperViewSmall", {
      slidesPerView: 2,
      spaceBetween: 10,
      pagination: {
          el: ".swiper-pagination-view",
          clickable: true,
      },
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 5,
        },
        1024: {
          slidesPerView: 7,
        },
      },
  });
}

function quantitySelector(){
  $('[data-quantity-selector]').each(function(){
    qSelector(this);
  });

  function qSelector(el){
    var input = $(el).find('[data-quantity-input]');
    var minus = $(el).find('[data-quantity-minus]');
    var plus = $(el).find('[data-quantity-plus]');

    $(input).off().on('input', function(){
      setValue($(this).val());
    });
    
    $(minus).off().on('click', function(){
      setValue($(input).val(), -1);
    });
    
    $(plus).off().on('click', function(){
      setValue($(input).val(), 1);
    });

    function setValue(str, add=0){
      try{
        var val = parseInt(str);
        if(!val || val <= 0 || val == NaN){
          $(input).val(1);
        } else {
          if(add != 0)
            val = val + add;
          if(val > 0)
            $(input).val(val);
        }
      } catch(e){
        $(input).val(1);
      }
    }
  }
}


function sliderProd(){
  var swiper = new Swiper(".mySwiperProd", {
    pagination: {
      el: ".swiper-pagination-prod",
    },
  });
}




class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          console.log(recommendations);

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            swipers();
            addToCart();
            quantitySelector();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



function filterPrice(){
  $('[data-uislider]').each(function(){
    var min = Number($(this).attr('data-uislider-from'));
    var max = Number($(this).attr('data-uislider-to'));
    var start = Number($(this).attr('data-uislider-min'));
    var end = Number($(this).attr('data-uislider-max'));
    var symbol = $(this).attr('data-uislider-symbol');
    var minparam = $(this).attr('data-uislider-minparam');
    var maxparam = $(this).attr('data-uislider-maxparam');

    var parent = $(this).parents('[data-uislider-parent]');
    var minvalue = $(parent).find('[data-uislider-minvalue]');
    var maxvalue = $(parent).find('[data-uislider-maxvalue]');

    var url = new URL(location.href);
    
    if(this.noUiSlider == undefined){
      var slider = noUiSlider.create(this, {
        start: [start, end],
        connect: true,
        'step': 500,
        range: {
          'min': min,
          'max': max
        }
      }, true);
      slider.on('update', function(values){
        $(minvalue).text(symbol+(values[0]/100).toFixed(2));
        $(maxvalue).text(symbol+(values[1]/100).toFixed(2));
      });
      if(minparam != undefined && maxparam != undefined){
        slider.on('change', function(values){
          if(values[0] != start)
            url.searchParams.set(minparam, values[0]/100);
          if(values[1] != end)
            url.searchParams.set(maxparam, values[1]/100);
          if(values[0] != start || values[1] != end){
            location.href = url;
          }
        });
      }
    }
  });
}

function cart(){
  $('.cart-quantity-selector [data-quantity-minus]').on('click',function(){
    $(this).parents('form').trigger('submit');
  });
  $('.cart-quantity-selector [data-quantity-plus]').on('click',function(){
    $(this).parents('form').trigger('submit');
  })
}

function megamenu(){
  $('[data-megamenu]').on("mouseover",function(){
    var id = $(this).attr('data-megamenu');
    $('.megamenu').addClass('d-none');
    $('#megamenu-'+id).removeClass('d-none');
  });


  $('.megamenu').on("mouseleave",function(){
    closeMenu();
  });


  $('[data-link2]').on("mouseover",function(){
    $('.tabber_2').addClass('d-none');
    var id = $(this).attr('data-link2');
    $(id).removeClass('d-none');
  });

  function closeMenu(){
    $('.megamenu').addClass('d-none'); 
    $('.tabber_2').addClass('d-none');
  }
}


function product(){
  $('#buy_now').on('click', function(){
    Swal.fire({
      title: '',
      html: "Cliccando su \"Compra ora\" dichiaro di essere maggiorenne, di accettare i termini e le condizioni generali del servizio e di aver letto la  <a href=\"https:\/\/www.iubenda.com\/privacy-policy\/35377387\" target=\"_blank\"> <u> Privacy Policy di Drogheria Pedrelli <\/u> <\/a> " ,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#008000',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Esci',
      confirmButtonText: 'Compra ora'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          '',
          'Stai per essere reinderizzato al check-out',
          'success'
        );
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: new FormData($('#product_id').get(0)),
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            location.href = '/checkout';
          },
          error: function (err) {
            console.log(err);
          }
        });
      }
    })
    
  });

}

function productMob(){
  $('#buy_now_mob').on('click', function(){
    Swal.fire({
      title: '',
      html: "Cliccando su \"Compra ora\" dichiaro di essere maggiorenne, di accettare i termini e le condizioni generali del servizio e di aver letto la  <a href=\"https:\/\/www.iubenda.com\/privacy-policy\/35377387\" target=\"_blank\"> <u> Privacy Policy di Drogheria Pedrelli <\/u> <\/a> " ,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#008000',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Esci',
      confirmButtonText: 'Compra ora'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          '',
          'Stai per essere reinderizzato al check-out',
          'success'
        );
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: new FormData($('#product_id').get(0)),
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            location.href = '/checkout';
          },
          error: function (err) {
            console.log(err);
          }
        });
      }
    })
    
  });
}

function menuMobile(){
  $('[data-menu]').on('click',function(){
    var id = $(this).attr('data-menu');
    $(id).toggleClass('d-none');
  })
}


function stickyMobile(){
  $('.btn_details').on('click',function(){
    $('.btn_mobile').addClass('d-none');
    $('.details_close').removeClass('d-none');
  });

  $('.details_close').on('click',function(){
    $('.btn_mobile').removeClass('d-none');
    $('.details_close').addClass('d-none');
  });
}

function addToCart(){
  $('[data-add-cart]').on('click', function(){
    var form = $(this).parents('form');
    var data = new FormData($(form).get(0));
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (d) {
        $(window).trigger('theme-add-cart', d);
        location.href = '/cart';
      },
      error: function (err) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: err.responseJSON.description + " " + "Abbiamo aggiunto al tuo carrello la quantità massima di prodotto disponibile",
        })
        console.log(err);
      }
    });
  });
}



function invoice(){


  $('#invoice').on('click',function(){
      $('#customer_type').toggleClass('d-none');
      $('#wrapper_fields').toggleClass('d-none');
      $('#customer_private_fields').find('input').val('');
      $('#company_fields').find('input').val('');
      $('#customer_type').find('input').removeAttr('required');
  });

  $('#private').on('click',function(){
      $('#customer_private_fields').removeClass('d-none');
      $('#company_fields').addClass('d-none');
      $('#customer_private_fields').find('input').val('');
  });


  $('#company').on('click',function(){
      $('#company_fields').removeClass('d-none');
      $('#customer_private_fields').addClass('d-none');
      $('#company_fields').find('input').val('');
  });


  $('#private').on('change',function(){
      console.log($(this).is(':checked'));
      if($(this).is(':checked')){
          $('#company_fields').find('input').removeAttr('required');
          $('#codice_fiscale').attr('required',true);
      }
  });


  $('#invoice').on('change',function(){
      if($(this).is(':checked')){
          $(this).parents('.cart__item-row').find('input').attr('required',true);
      }
      else{
          $(this).parents('.cart__item-row').find('input').removeAttr('required');
          $(this).parents('.cart__item-row').find('input').val('');
          $(this).parents('.cart__item-row').find('input').prop('checked', false);            
      }
  });


  $('#company').on('change',function(){
      console.log($(this).is(':checked'));
      if($(this).is(':checked')){
          $('#customer_private_fields').find('input').removeAttr('required');
          $('#company_fields').find('input').attr('required',true);
          $('#codice_fiscale_comp').removeAttr('required');
      }
  });

  $('#codice_fiscale_comp').on('blur',function(){
      if($(this).val().length > 0){
          $('#partita_iva').removeAttr('required');
      }
      else{
          $('#partita_iva').attr('required',true);
      }
  });




  // regalo
  $('#gift').on('change',function(){
    if($(this).is(':checked')){
      $('#text_gift').removeClass('d-none');
    }
    else{
      $('#text_gift').addClass('d-none');
      $(this).parents('.gift_row').find('input').val('');           
    }
  });

}



function addressForm(){
  $('.address-form').each(function(){
    address(this);
  });

  function address(form){
    var province = $(form).find('[data-province-select]');
    var country = $(form).find('[data-country-select]');
    setProvince();

    $(country).on('change', setProvince);
    function setProvince(){
      try {
        var provinces = JSON.parse($(country).find('option:selected').attr('data-provinces'));
        if(provinces.length){
          var p = ['<option value=""></option>'];
          $(provinces).each(function(){
            p.push('<option value="'+this[0]+'">'+this[0]+'</option>');
          });
          $(province).html(p.join(''));
        } else {
          $(province).html("");
        }
      } catch{
        $(province).html("");
      }
    }
  }

}